module.exports = {
  'Wait a minute': 'Espera un momento',
  'Please do not update or reload this screen': 'Por favor, no actualices o recargues esta pantalla.',
};
